import english from './en'
import spanish from './spanish'
import portuguese from './portuguese'
import enLocale from 'element-ui/lib/locale/lang/en'
import ptLocale from 'element-ui/lib/locale/lang/pt' // 葡萄牙
import esLocale from 'element-ui/lib/locale/lang/es' // 西班牙
export default {
  english: {
    ...english, // 英语
    ...enLocale
  },
  spanish: {
    ...spanish, // 西班牙语
    ...esLocale
  },
  portuguese: {
    ...portuguese, // 葡萄牙语
    ...ptLocale
  }
}
